// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yOxl","delete":"styles_delete__176Gn","update":"styles_update__2_B_Z","add":"styles_add__3Rtm-"};